// import React, { Component } from "react";
// import * as echarts from "echarts/dist/echarts.js";
// import "bootstrap/dist/css/bootstrap.css";
// import "./dashboard.css";
// import {
//   getSystemRealTimeData,
//   getSystemLatestData,
//   getSystemBasics,
//   ws_getSystemLatestData,
//   getSystemInfo,
// } from "../services/systemService";

// import { webSocketMode } from "../config.json"; //0: http; 1:websocket

// class ChartOnTime extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       graphLen: 0,
//       base: new Date(),
//       oneDay: 86400000,
//       date: [],
//       value1: [0],
//       value2: [0],
//       value3: [0],
//       value4: [0],
//       now: new Date(),
//     };
//   }

//   async componentDidMount() {
//     this.chart = echarts.init(document.getElementById("onTime-chart"));
//     const tickNumber = 1000;
//     this.timerID = setInterval(() => this.tick(), tickNumber);

//     const thisTime = this.props.dataDate;
//     console.log("This Time: ", thisTime);
//     const dateLength = thisTime.length;
//     let thisHumanTime = [];
//     let thisHumanDate = 0;
//     let d = 0;
//     let timeZone = this.props.timeZone;
//     for (let i = 0; i < dateLength; i++) {
//       d = new Date(thisTime[i] /*- timeZone * 3600*/ * 1000);
//       thisHumanDate = thisHumanTime[i] = [
//         d.getUTCMonth() + 1,
//         d.getUTCDate(),
//         d.getUTCFullYear(),
//       ].join("/");
//       thisHumanTime[i] = [d.getUTCHours(), d.getUTCMinutes()].join(":");
//       thisHumanTime[i] = [thisHumanDate, thisHumanTime[i]].join(" @ ");
//     }
//     console.log("This Human Time: ", thisHumanTime);
//     this.setState({ thisHumanTime });
//     this.generateGraph();
//   }

//   componentWillUnmount() {
//     clearInterval(this.timerID);
//   }

//   tick() {
//     this.chart.setOption({
//       yAxis: {
//         max: 105,
//       },
//       xAxis: {
//         data: this.state.thisHumanTime,
//         axisTick: { show: true },
//         splitLine: { show: true },
//       },
//       series: [
//         {
//           name: "onTimeCool1 (%)",
//           data: this.props.onTimeCool1,
//         },
//         {
//           name: "onTimeCool2 (%)",
//           data: this.props.onTimeCool2,
//         },
//         {
//           name: "onTimeHeat1 (%)",
//           data: this.props.onTimeHeat1,
//         },
//         {
//           name: "onTimeHeat2 (%)",
//           data: this.props.onTimeHeat2,
//         },
//       ],
//     });
//   }

//   generateGraph() {
//     var option = {
//       grid: {
//         top: 10,
//         bottom: 20,
//         left: "10%",
//         right: "10%",
//       },
//       /* legend: {
//         type: "scroll",
//         data: [
//           "onTimeCool1 (%)",
//           "onTimeCool2 (%)",
//           "onTimeHeat1 (%)",
//           "onTimeHeat2 (%)",
//         ],
//         center: "50%",
//         top: "0%",
//         orient: "horizontal",
//         align: "auto",
//         padding: 3,
//         textStyle: {
//           fontStyle:
//             "normal" ,
//           fontSize: 10,
//           fontWeight: "bold",
//           color: "grey",
//         },
//         backgroundColor: "transparent",
//         borderColor: "#ffffff",
//         borderWidth: 1,
//         boarderRadius: 0,
//       },*/
//       xAxis: {
//         name: "",
//         nameLocation: "end",
//         type: "category",
//         nameTextStyle: {
//           fontStyle:
//             "normal" /*'Lato,"Helvetica Neue",Arial,Helvetica,sans-serif'*/,
//           fontSize: 16,
//           fontWeight: "bolder",
//           color: "green",
//         },
//         axisLabel: {
//           fontStyle: "normal",
//           fontSize: 8,
//           fontWeight: "normal",
//           color: "orange",
//         },
//         boundaryGap: false,
//         data: this.state.thisHumanTime,
//       },
//       yAxis: {
//         show: false,
//         name: "Power (Watts)",
//         nameLocation: "end",
//         boundaryGap: [0, "10%"],
//         type: "value",
//         nameTextStyle: {
//           fontStyle:
//             "normal" /*'Lato,"Helvetica Neue",Arial,Helvetica,sans-serif'*/,
//           fontSize: 16,
//           fontWeight: "bolder",
//           color: "green",
//         },
//         axisLabel: {
//           fontStyle: "normal",
//           fontSize: 10,
//           fontWeight: "bold",
//           color: "green",
//         },
//       },
//       /* dataZoom: [
//         {
//           type: "slider",
//           show: true,
//           xAxisIndex: [0],
//           start: 1,
//           end: 100,
//         },
//         {
//           type: "inside",
//           xAxisIndex: [0],
//           start: 1,
//           end: 100,
//         },
//       ],*/
//       series: [
//         {
//           name: "onTimeCool1 (%)",
//           type: "line",
//           symbol: "none",
//           color: "blue",
//           smooth: 0.25,
//           data: this.props.onTimeCool1,
//         },
//         {
//           name: "onTimeCool2 (%)",
//           type: "line",
//           symbol: "none",
//           color: "dodgerblue",
//           smooth: 0.25,
//           data: this.props.onTimeCool2,
//         },
//         {
//           name: "onTimeHeat1 (%)",
//           type: "line",
//           symbol: "none",
//           color: "tomato",
//           smooth: 0.25,
//           data: this.props.onTimeHeat1,
//         },
//         {
//           name: "onTimeHeat2 (%)",
//           type: "line",
//           symbol: "none",
//           color: "red",
//           smooth: 0.25,
//           data: this.props.onTimeHeat2,
//         },
//       ],
//       tooltip: {
//         trigger: "axis",
//         axisPointer: {
//           animation: false,
//           type: "cross",
//           label: {
//             backgroundColor: "#6a7985",
//             precision: "2",
//           },
//         },
//       },
//       // axisPointer: {
//       //   link: { xAxisIndex: "all", yAxisName: "Return T (F)" },
//       //   label: {
//       //     backgroundColor: "#777",
//       //   },
//       // },
//     };

//     this.chart.setOption(option);
//   }

//   render() {
//     return <div id="onTime-chart" />;
//   }
// }
// export default ChartOnTime;

import React, { Component } from "react";
import * as echarts from "echarts/dist/echarts.js";
import "bootstrap/dist/css/bootstrap.css";
import "./dashboard.css";

class ChartOnTime extends Component {
  constructor(props) {
    super(props);
    this.chart = null;

    this.state = {
      thisHumanTime: [],
    };
  }

  componentDidMount() {
    this.chart = echarts.init(document.getElementById("onTime-chart"));
    this.buildHumanTime();
    this.updateChartFromProps();

    this.timerID = setInterval(() => this.tick(), 1000);
  }

  componentDidUpdate(prevProps) {
    // If timestamps change → rebuild x-axis and full chart
    if (prevProps.dataDate !== this.props.dataDate) {
      this.buildHumanTime();
      this.updateChartFromProps();
    }

    // If only the values changed → update series only
    if (
      prevProps.onTimeCool1 !== this.props.onTimeCool1 ||
      prevProps.onTimeCool2 !== this.props.onTimeCool2 ||
      prevProps.onTimeHeat1 !== this.props.onTimeHeat1 ||
      prevProps.onTimeHeat2 !== this.props.onTimeHeat2
    ) {
      this.updateSeriesData();
    }
  }

  componentWillUnmount() {
    clearInterval(this.timerID);
    if (this.chart) this.chart.dispose();
  }

  //---------------------------------------------
  // Build X-axis Human Time
  //---------------------------------------------
  buildHumanTime() {
    const timestamps = Array.isArray(this.props.dataDate)
      ? this.props.dataDate
      : [];

    const thisHumanTime = timestamps.map((ts) => {
      const d = new Date(ts * 1000);
      const date = `${
        d.getUTCMonth() + 1
      }/${d.getUTCDate()}/${d.getUTCFullYear()}`;
      const hh = String(d.getUTCHours()).padStart(2, "0");
      const mm = String(d.getUTCMinutes()).padStart(2, "0");
      return `${date} @ ${hh}:${mm}`;
    });

    this.setState({ thisHumanTime });
  }

  //---------------------------------------------
  // FULL chart update (xAxis + structure + colors)
  //---------------------------------------------
  updateChartFromProps() {
    if (!this.chart) return;

    const option = {
      grid: {
        top: 10,
        bottom: 20,
        left: "10%",
        right: "1%",
      },

      tooltip: {
        trigger: "axis",
        axisPointer: {
          animation: false,
          type: "cross",
          label: {
            backgroundColor: "#6a7985",
            precision: "2",
          },
        },
      },

      xAxis: {
        type: "category",
        boundaryGap: false,
        data: this.state.thisHumanTime,
        axisTick: { show: true },
        splitLine: { show: true },
        axisLabel: {
          fontSize: 8,
          color: "orange",
        },
      },

      yAxis: [
        {
          type: "value",
          show: false,
          max: 105,
        },
        {
          show: false, //true,
          name: "Priority Level",
          position: "right",
          nameLocation: "end",
          splitLine: {
            show: false,
          },
          //boundaryGap: [0, "10%"],
          type: "value",
          nameTextStyle: {
            fontStyle: "normal",
            fontSize: 16,
            fontWeight: "bolder",
            color: "orange",
          },
          axisLabel: {
            fontStyle: "normal",
            fontSize: 10,
            fontWeight: "bold",
            color: "orange",
          },
        },
      ],

      series: [
        {
          name: "onTimeCool1 (%)",
          type: "line",
          color: "blue",
          symbol: "none",
          smooth: 0.25,
          data: this.props.onTimeCool1,
        },
        {
          name: "onTimeCool2 (%)",
          type: "line",
          color: "dodgerblue",
          symbol: "none",
          smooth: 0.25,
          data: this.props.onTimeCool2,
        },
        {
          name: "onTimeHeat1 (%)",
          type: "line",
          color: "tomato",
          symbol: "none",
          smooth: 0.25,
          data: this.props.onTimeHeat1,
        },
        {
          name: "onTimeHeat2 (%)",
          type: "line",
          color: "red",
          symbol: "none",
          smooth: 0.25,
          data: this.props.onTimeHeat2,
        },
        {
          name: "onTime",
          type: "line",
          step: "middle",
          yAxisIndex: 1,
          symbol: "none",
          color: "none",
          areaStyle: {
            normal: {
              color: "grey",
              opacity: "0.25",
            },
          },
          label: {
            show: true,
            position: "top",
          },
          data: this.props.onTime,
        },
      ],
    };

    this.chart.setOption(option, true);
  }

  //---------------------------------------------
  // SERIES ONLY update (fast, no re-render)
  //---------------------------------------------
  updateSeriesData() {
    if (!this.chart) return;

    this.chart.setOption({
      series: [
        {
          name: "onTimeCool1 (%)",
          type: "line",
          color: "blue",
          symbol: "none",
          smooth: 0.25,
          data: this.props.onTimeCool1 || [],
        },
        {
          name: "onTimeCool2 (%)",
          type: "line",
          color: "dodgerblue",
          symbol: "none",
          smooth: 0.25,
          data: this.props.onTimeCool2 || [],
        },
        {
          name: "onTimeHeat1 (%)",
          type: "line",
          color: "tomato",
          symbol: "none",
          smooth: 0.25,
          data: this.props.onTimeHeat1 || [],
        },
        {
          name: "onTimeHeat2 (%)",
          type: "line",
          color: "red",
          symbol: "none",
          smooth: 0.25,
          data: this.props.onTimeHeat2 || [],
        },
      ],
    });
  }

  //---------------------------------------------
  // LIVE tick every 1 second (uses both xAxis + series)
  //---------------------------------------------
  tick() {
    if (!this.chart) return;

    this.chart.setOption({
      yAxis: { max: 105 },
      xAxis: {
        data: this.state.thisHumanTime,
        axisTick: { show: true },
        splitLine: { show: true },
      },
      series: [
        { type: "line", name: "onTimeCool1 (%)", data: this.props.onTimeCool1 },
        { type: "line", name: "onTimeCool2 (%)", data: this.props.onTimeCool2 },
        { type: "line", name: "onTimeHeat1 (%)", data: this.props.onTimeHeat1 },
        { type: "line", name: "onTimeHeat2 (%)", data: this.props.onTimeHeat2 },
      ],
    });
  }

  render() {
    return (
      <div
        id="onTime-chart"
        // style={{ width: "100%", height: "200px" }}
      />
    );
  }
}

export default ChartOnTime;
